export default __webpack_public_path__ + "static/media/HOP.586a580f.png";